module.exports = __webpack_public_path__ + "static/hero@2x-6cb47d83f17310937793909499886ab6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/about-us/hero@2x.jpg
// module id = 2525
// module chunks = 168707334958949